exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/exports-loader?module.exports.toString()!/var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/postcss-loader?{"ident":"postcss"}!/var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module id = ../../../../exports-loader/index.js?module.exports.toString()!../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module chunks = main